import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { CommonApiService } from '../api/common-api.service';
import { AuthUserModel } from '../../models';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(
    private authService: CommonApiService,
    private cookieService: CookieService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('/login/email') || request.url.includes('/login/findUser') || request.url.startsWith('./')) {
      return next.handle(request);
    }

    if (!this.authService.isTokenValid()) {
      if (this.refreshTokenInProgress) {
        return this.refreshTokenSubject.pipe(
          filter((result) => result !== null),
          take(1),
          switchMap(() => next.handle(this.addToken(request)))
        );
      } else {
        this.refreshTokenInProgress = true;
        this.refreshTokenSubject.next(null);
        const user: AuthUserModel = this.authService.getUserDataFromToken();
        const email: string = user.secondary ? user.email : this.cookieService.get('auth-mail');

        return this.authService.ssoLogin(email)
          .pipe(
            switchMap((data: any) => {
              this.authService.setToken(data.token);
              this.refreshTokenInProgress = false;
              this.refreshTokenSubject.next(data.token);
              return next.handle(this.addToken(request));
            })
          );
      }
    }

    return next.handle(this.addToken(request));
  }

  private addToken(request: HttpRequest<any>): HttpRequest<any> {
    const token = this.authService.getToken();
    if (!token) {
      return request;
    }

    return request.clone({
      headers: request.headers.set('Authorization', `Bearer ${token}`)
    });
  }
}
